import { render, staticRenderFns } from "./InfoDisplayBox.vue?vue&type=template&id=37bf2c4a&"
import script from "./InfoDisplayBox.vue?vue&type=script&lang=ts&"
export * from "./InfoDisplayBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
